<template>
  <div>
    <Head title="Edit Group" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/groups">Groups</Link>
      <span class="text-orange-400 font-medium">/</span> Edit {{ group.name }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.group_name" :error="form.errors.group_name" class="pb-8 pr-6 w-full lg:w-full" label="Group name" />
        </div>
        <div class="flex flex-wrap mb-10 -mr-6 pl-8 pb-8 w-full lg:w-full pb-2 pr-8">
          <label class="pt-1 pb-1">Permissions:</label>
          <multiselect
            id="permission"
            v-model="form.permissions"
            placeholder="Search Permissions"
            :options="allPermissions"
            :clear-on-select="false"
            :preserve-search="true"
            :searchable="true"
            mode="tags"
            :close-on-select="false"
            :create-option="true"
            :error="form.errors.permissions"
            :style="form.errors.permissions ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
          />
          <div v-if="form.errors.permissions" class="form-error">{{ form.errors.permissions }}</div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Update Group</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
    
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Layout from '@/Shared/Layout'
import Multiselect from '@vueform/multiselect'
    
export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    group: Object,
    allPermissions: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        group_name: this.group.name,
        permissions: this.group.permissions,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/groups/${this.group.id}`, {
        onSuccess: () => this.form.reset('group_name'),
      })
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>